module.exports = __webpack_public_path__ + "img/mergeShape.95b516eb.png";